import { useCallback } from 'react';
import { apiCreateProfessionalRfpMessageLog } from '@/actions/ProRfpShareDocumentActions';
/**
 * 未読カウント/既読処理の制御
 */
export const useRfpProfessionalFileMessageLog = (options) => {
    const { changeFileShareData, dispatch, id } = options;
    /**
     * 最終メッセージ表示イベント：閲覧申請一覧から、指定IDの既読カウントを0にする
     */
    const displayLastMessage = useCallback((messageId) => {
        // 既読APIを実行
        dispatch(apiCreateProfessionalRfpMessageLog({
            path: {
                id,
                shareDocumentMessageId: messageId,
            },
        }, {}));
        // メッセージの未読系の値を既読状態にする
        changeFileShareData((prevState) => {
            if (!prevState) {
                return null;
            }
            return Object.assign(Object.assign({}, prevState), { messages: prevState.messages.map((message) => (Object.assign(Object.assign({}, message), { is_unread: false }))), unread_count: 0 });
        });
    }, [dispatch, id, changeFileShareData]);
    return {
        displayLastMessage,
    };
};
